import type { ColorSchemeMode } from './ColorSchemeMode';
import type { IColorScheme } from './IColorScheme';
import type { IColorSchemeSeed } from './IColorSchemeSeed';
import type { IColorSchemeTokens } from './IColorSchemeTokens';
import { DARK_SCHEME_SEEDS } from './darkSchemeSeeds';
import { LIGHT_SCHEME_SEEDS } from './lightSchemeSeeds';
import { darkTokens, lightTokens } from './schemeTokens';

const build = (seed: IColorSchemeSeed, mode: ColorSchemeMode, tokens: IColorSchemeTokens): IColorScheme =>
  ({ id: seed.id, label: seed.label, mode, tokens });

/** Усі 50 колірних схем v4: 25 світлих, потім 25 темних (порядок профілю прототипу); перша — типова «Парламент». */
export const COLOR_SCHEMES: readonly IColorScheme[] = [
  ...LIGHT_SCHEME_SEEDS.map((s) => build(s, 'light', lightTokens(s))),
  ...DARK_SCHEME_SEEDS.map((s) => build(s, 'dark', darkTokens(s))),
];
